<app-form-view [formDataModel]="costingData"
    [formItems]="costingFormItems"
    (onSave)="onSaveClicked($event)"
    (onCancel)="onCancelClicked($event)"></app-form-view>
